import { requestService } from 'shared/utils/services/requestService';

export const logToFriendlyLogs = async (headers) => {
  try {
    await requestService({
      url: '/friendly-logs',
      method: 'POST',
      headers,
    });
  } catch {
    // do nothing
  }
};
